import React from "react";
import {
  Dialog,
  Box,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import colors from "../../assest/theme/base/colors";
import MaterialTypography from "../../components/MaterialTypography";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../components/MaterialInput";
import MaterialButton from "../../components/MaterialButton";
import { handleChangeDispatch } from "./FilterReducer";


const ReusableFilter = ({
  open,
  onClose,
  onSave,
  data,
  dispatch,
  title,
  children,
  dateFalse = true,
  isButtonValid
}) => {
  const isFormValid =
    data?.fromDateStatus === "success" && data?.toDateStatus === "success";

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 3,
          padding: 3,
        },
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Grid container spacing={3} mt={1}>
        {/* From Date */}
       { dateFalse && <Grid size={{ xs: 12, md: 6 }}>
          <MaterialTypography component="label" variant="caption" fontWeight="bold">
            From Date <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            fullWidth
            type="date"
            name="fromDate"
            value={data?.fromDate || ""}
            onChange={(e) => handleChangeDispatch(e, dispatch)}
            error={data?.fromDateStatus === "error"}
            inputProps={{ max: new Date().toISOString().split("T")[0] }}
          />
        </Grid>}

        {/* To Date */}
        {dateFalse && <Grid size={{ xs: 12, md: 6 }}>
          <MaterialTypography component="label" variant="caption" fontWeight="bold">
            To Date <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            fullWidth
            type="date"
            name="toDate"
            value={data?.toDate || ""}
            onChange={(e) => handleChangeDispatch(e, dispatch)}
            error={data?.toDateStatus === "error"}
            inputProps={{
              min: data?.fromDate || undefined,
              max: new Date().toISOString().split("T")[0],
            }}
          />
        </Grid>}


        {/* Optional children */}
        {children}

        {/* Buttons */}
        <Grid size={{ xs: 12 }}>
          <Box display="flex" justifyContent="center" gap={2}>
            <MaterialButton
              variant="contained"
              onClick={onSave}
              disabled={isButtonValid ? !isButtonValid : !isFormValid}
              sx={{
                background: colors?.buttonColor || "#1976d2",
                color: "#fff",
                textTransform: "capitalize",
              }}
            >
              Submit
            </MaterialButton>
            <MaterialButton variant="outlined" color="error" onClick={onClose}>
              Cancel
            </MaterialButton>
          </Box>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default ReusableFilter;
